module.exports = __webpack_public_path__ + "img/shops-and-marketplaces.97f4de7d.svg";